import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import Title from '../Components/Title';
import SmallTitle from '../Components/SmallTitle';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import SchoolIcon from '@material-ui/icons/School';
import ResumeItem from '../Components/ResumeItem';
import Particle from './Particle';

function Resume() {
  const briefcase = <BusinessCenterIcon />;
  const school = <SchoolIcon />;
  return (
    <ResumeStyled>
      <Particle />
      <Title title={'Resume'} span={'resume'} />
      <InnerLayout>
        <div className="small-title">
          <SmallTitle icon={briefcase} title={'Working Experience'} />
        </div>
        <div className="resume-content">
          <ResumeItem year={'2022 - Present'} title={'Cloud Engineer'} subTitle={'Wipro'} text={'Google Workspace Engineer - Support, Implementation, Configuration and ongoing technical support (L2/L3) for global customers in Europe and America regions. Adoption & Change Management Solution Provider using native tools, such as, AppSheet and App Script for automation, workflows and legacy systems replacement/dependency (e.g., workday, procurement, supply chain). Google Voice and ChromeOS Implementation'} />
          <ResumeItem
            year={'2021 - 2022'}
            title={'System Engineer'}
            subTitle={'Axians'}
            text={'Technical Support - Active Directory Management and Support. Monitoring and Managing end users and network Devices'}
          />
          <ResumeItem
            year={'2018 - 2021'}
            title={'Front-End Developer'}
            subTitle={'Freelancer'}
            text={'Development of Websites using HTML, CSS, JS and REACT JS'}
          />
          <ResumeItem
            year={'2018 - 2019'}
            title={'Intership'}
            subTitle={'EmbraceRAD'}
            text={'Development of WebApps and MobileApps using OutSystems Platform'}
          />
          <Particle />
          <ResumeItem
            year={'2018'}
            title={'Communication and Multimedia Services'}
            subTitle={'Communication Castelo Branco'}
            text={'Development in design using Adobe Illustrator, Photoshop and 3D modeling in Cinema 4D Platform'}
          />
        </div>

        <div className="small-title u-small-title-margin">
          <SmallTitle icon={school} title={'Educational Qualifications'} />
        </div>
        <Particle />
        <div className="resume-content ">
          <ResumeItem
            year={'2018 - 2022'}
            title={'Bachelor Degree'}
            subTitle={'Instituto Politécnico de Castelo Branco'}
            text={'Bachelor in Computer Engineering'}
          />
          <ResumeItem
            year={'2020 - 2021'}
            title={'Erasmus+'}
            subTitle={'Bialystok University of Technology'}
            text={'One semester in Computer Engineering Abroad in Bialystok, Poland '}
          />

          <ResumeItem
            year={'2018 - 2019'}
            title={'Outsystems and Javascript Course'}
            subTitle={'EmbraceRAD'}
            text={'Instituto do Emprego e Formação Profissional OutSystems and JavaScript Course'}
          />

          <ResumeItem
            year={'2016 - 2018'}
            title={'Associate Degree - CTeSP'}
            subTitle={'Instituto Politécnico de Castelo Branco'}
            text={'Specialize Course in Development of Multimedia Products'}
          />

          <ResumeItem
            year={'2012 - 2015'}
            title={'High School'}
            subTitle={'Escola Secundária Nuno Álvares'}
            text={'Special Course in Renewable Energy'}
          />
        </div>
      </InnerLayout>
    </ResumeStyled>
  );
}

const ResumeStyled = styled.section`
  .small-title {
    padding-bottom: 3rem;
  }
  .u-small-title-margin {
    margin-top: 4rem;
  }

  .resume-content {
    border-left: 2px solid var(--border-color);
  }
`;
export default Resume;
